export const companyNameInJapanese_1 = "パナソニック電材ソリューションズ株式会社";
export const companyNameInJapanese_2 =  "パナソニック電材ソリューションズ";
export const companyNameInEnglish_1 = "Panasonic Electrical Construction Materials Solutions Co., Ltd.";
export const companyNameInEnglish_2 = "Panasonic Electrical Construction Materials Solutions";